/* eslint-disable no-shadow */
export var ELocalStorageKeys;
(function (ELocalStorageKeys) {
    ELocalStorageKeys["TOKEN"] = "token";
    ELocalStorageKeys["VALID"] = "valid";
    ELocalStorageKeys["GAME_MASTER_ID"] = "gameMasterId";
})(ELocalStorageKeys || (ELocalStorageKeys = {}));
